import React from 'react';
import { useTranslation } from 'react-i18next';

/** Нейтральное сообщение при пустой выборке. */
export default function EmptyState({ text }) {
  const { t } = useTranslation();
  return <div className="sch-empty">{text || t('schools.noRows')}</div>;
}
